import classNames from 'classnames';
import React from 'react';

import { BaseModelBasicData, SizeData } from '../../../../data/model';
import { AnalyticsAttributes } from '../../../../shared/analytics/AnalyticsAttributes';
import PreloadedImage from '../../../../shared/components/PreloadedImage';
import { SelectorItem } from '../../../../shared/Selector';
import { VisualizationAspectRatio } from '../../../../shared/visualization';
import css from './ProductModelSelectorItem.css';

interface ProductModelSelectorItemProps {
  item: SelectorItem<BaseModelBasicData>;
  handleClick: () => void;
  style?: React.CSSProperties;
  width: number;
  height: number;
}

const getImageWidth = (
  targetHeight: number,
  fallbackWidth: number,
  aspectRatio: string,
  originalImageSize?: SizeData,
) => {
  if (!originalImageSize) {
    return fallbackWidth * (aspectRatio === VisualizationAspectRatio.Default ? 1 : 2);
  }

  const targetWidth = (targetHeight * originalImageSize.width) / originalImageSize.height;
  return targetWidth;
};

const ProductModelSelectorItem = ({ item, handleClick, style }: ProductModelSelectorItemProps) => {
  const {
    data: { displayName, outline, shortDescription, visualizationAspectRatio, predefinedConfigurations },
    isActive,
  } = item;

  return (
    <div
      className={classNames(css.ProductModelSelectorItem, isActive && css.isActive)}
      style={style}
      onClick={handleClick}
      {...AnalyticsAttributes.get({
        id: 'Choose model',
        label: shortDescription,
        product: displayName,
        'product-code': predefinedConfigurations[0]?.code,
      })}
    >
      <div className={css.imageWrapper}>
        <PreloadedImage
          className={css.image}
          fallbackClass={css.fallback}
          src={outline?.url}
          alt={displayName}
          width={getImageWidth(170, 120, visualizationAspectRatio, outline?.size)}
          height={170}
        />
        {(!outline || !outline.url) && <span className={css.name}>{displayName}</span>}
      </div>
      {shortDescription && <p className={css.shortDescription}>{shortDescription}</p>}
    </div>
  );
};

export default ProductModelSelectorItem;
